const rolesApi = ({ apiClient }) => ({
  list() {
    return apiClient.get('roles')
  },
  show(id) {
    return apiClient.get(`roles/${id}`)
  },
  store(payload = {}) {
    return apiClient.post('roles', payload)
  },
  update(id, payload = {}) {
    return apiClient.put(`roles/${id}`, payload)
  },
  destroy(id) {
    return apiClient.delete(`roles/${id}`)
  },
})
export default rolesApi
